import { RequestRemark } from "./Request";

export enum OutsideEnrollmentAreaStatus {
  /// <summary>
  /// Nije obrađeno<br/>
  /// Na postupku upisa naznačeno da roditelj/skrbnik želi dijete upisati u školu izvan upisnog područja
  /// </summary>
  NotProcessed = 1,
  /// <summary>
  /// Sugeriran upis - prihvaćeno<br/>
  /// Škola izvan upisnog područja je sugerirala ima li mjesta za školskog obveznika u njihovoj školi ili ne
  /// </summary>
  SuggestedEnrollmentAccepted = 4,
  /// <summary>
  /// Sugeriran upis - odbijeno<br/>
  /// Škola izvan upisnog područja je sugerirala ima li mjesta za školskog obveznika u njihovoj školi ili ne
  /// </summary>
  SuggestedEnrollmentRejected = 5,
  /// <summary>
  /// Donesena odluka – upis van upisnog područja<br/>
  /// UO/GU donio odluku o osnovnoj školi i odobrio upis škole van upisnog područja ili rješenje o upisu na kojem je odobrena odabrana škola van upisnog područja
  /// </summary>
  DecisionAccepted = 6,
  /// <summary>
  /// Donesena odluka – upis po upisnom području<br/>
  /// UO/GU donio odluku o osnovnoj školi i odbio upis škole van upisnog područja ili rješenje o upisu na kojem je odbijena odabrana škola van upisnog područja
  /// </summary>
  DecisionDeclined = 7,
}

export interface SetOutsideEnrollmentAreaStatusPayload {
  requestId: number;
  outsideEnrollmentAreaStatus: OutsideEnrollmentAreaStatus;
  isApproved: boolean;
  request?: Request;
  requestRemark: RequestRemark;
}
